// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.championship-editor {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #0f172a;
  position: relative;
}

.championship-editor-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #94a3b8;
  font-size: 16px;
  padding: 32px;
  text-align: center;
}

.championship-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: #1e293b;
  border-bottom: 1px solid #334155;
}

.championship-editor-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #f1f5f9;
}

.championship-editor-actions {
  display: flex;
  gap: 12px;
}

.championship-editor-actions button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.championship-editor-actions .cancel-button {
  background: #0f172a;
  color: #f1f5f9;
  border: 1px solid #475569;
}

.championship-editor-actions .cancel-button:hover {
  background: #334155;
}

.championship-editor-actions .save-button {
  background: #3b82f6;
  color: white;
  border: 1px solid #3b82f6;
}

.championship-editor-actions .save-button:hover:not(:disabled) {
  background: #2563eb;
  border-color: #2563eb;
}

.championship-editor-actions .save-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.championship-editor-tabs {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  overflow: hidden;
}

.championship-editor-tabs .tabs-header-wrapper {
  position: relative;
  background: #1e293b;
  border-bottom: 1px solid #334155;
}

.championship-editor-tabs .tabs-header-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 40px;
  background: linear-gradient(to right, transparent, #1e293b);
  pointer-events: none;
}

.championship-editor-tabs .tabs-header {
  display: flex;
  gap: 4px;
  padding: 16px 24px 0 24px;
  background: #1e293b;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.championship-editor-tabs .tabs-header::-webkit-scrollbar {
  display: none;
}

.championship-editor-tabs .tab-button {
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #94a3b8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.championship-editor-tabs .tab-button:hover:not(:disabled) {
  color: #f1f5f9;
  background: #334155;
}

.championship-editor-tabs .tab-button.active {
  color: #3b82f6;
  border-bottom-color: #3b82f6;
}

.championship-editor-tabs .tab-button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: #64748b;
}

.championship-editor-tabs .tabs-content {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background: #0f172a;
}

.unsaved-changes-indicator {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 20px;
  background: rgba(251, 191, 36, 0.9);
  color: #78350f;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 50;
}

/* Common form styles for all tabs */
.championship-tab-content {
  max-width: 1200px;
}

.form-section {
  margin-bottom: 32px;
}

.form-section h3 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  color: #f1f5f9;
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 13px;
  font-weight: 500;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 6px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 12px;
  background: #1e293b;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 14px;
  font-family: inherit;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3b82f6;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-group input[type="checkbox"] {
  width: auto;
  cursor: pointer;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.checkbox-group label {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

/* Championship draft/live status toggle */
.champ-status-section {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  padding: 12px 16px !important;
}

.champ-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.champ-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  flex-shrink: 0;
}

.champ-status-badge.draft {
  background: #374151;
  color: #9ca3af;
  border: 1px solid #4b5563;
}

.champ-status-badge.live {
  background: #14532d;
  color: #4ade80;
  border: 1px solid #16a34a;
}

.champ-status-hint {
  font-size: 13px;
  color: #94a3b8;
  flex: 1 1 auto;
}

.champ-status-toggle {
  padding: 6px 14px;
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  flex-shrink: 0;
  transition: background 0.15s;
}

.champ-status-toggle.publish {
  background: #16a34a;
  color: #fff;
}

.champ-status-toggle.publish:hover {
  background: #15803d;
}

.champ-status-toggle.unpublish {
  background: #374151;
  color: #d1d5db;
}

.champ-status-toggle.unpublish:hover {
  background: #1f2937;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChampionshipEditor.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,2DAA2D;EAC3D,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,WAAW;AACb;;AAEA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;EAGE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".championship-editor {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  background: #0f172a;\r\n  position: relative;\r\n}\r\n\r\n.championship-editor-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n  color: #94a3b8;\r\n  font-size: 16px;\r\n  padding: 32px;\r\n  text-align: center;\r\n}\r\n\r\n.championship-editor-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 20px 24px;\r\n  background: #1e293b;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.championship-editor-header h2 {\r\n  margin: 0;\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.championship-editor-actions {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.championship-editor-actions button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.championship-editor-actions .cancel-button {\r\n  background: #0f172a;\r\n  color: #f1f5f9;\r\n  border: 1px solid #475569;\r\n}\r\n\r\n.championship-editor-actions .cancel-button:hover {\r\n  background: #334155;\r\n}\r\n\r\n.championship-editor-actions .save-button {\r\n  background: #3b82f6;\r\n  color: white;\r\n  border: 1px solid #3b82f6;\r\n}\r\n\r\n.championship-editor-actions .save-button:hover:not(:disabled) {\r\n  background: #2563eb;\r\n  border-color: #2563eb;\r\n}\r\n\r\n.championship-editor-actions .save-button:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.championship-editor-tabs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  overflow: hidden;\r\n}\r\n\r\n.championship-editor-tabs .tabs-header-wrapper {\r\n  position: relative;\r\n  background: #1e293b;\r\n  border-bottom: 1px solid #334155;\r\n}\r\n\r\n.championship-editor-tabs .tabs-header-wrapper::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  width: 40px;\r\n  background: linear-gradient(to right, transparent, #1e293b);\r\n  pointer-events: none;\r\n}\r\n\r\n.championship-editor-tabs .tabs-header {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 16px 24px 0 24px;\r\n  background: #1e293b;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.championship-editor-tabs .tabs-header::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.championship-editor-tabs .tab-button {\r\n  padding: 12px 20px;\r\n  background: transparent;\r\n  border: none;\r\n  border-bottom: 2px solid transparent;\r\n  color: #94a3b8;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.championship-editor-tabs .tab-button:hover:not(:disabled) {\r\n  color: #f1f5f9;\r\n  background: #334155;\r\n}\r\n\r\n.championship-editor-tabs .tab-button.active {\r\n  color: #3b82f6;\r\n  border-bottom-color: #3b82f6;\r\n}\r\n\r\n.championship-editor-tabs .tab-button.disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n  color: #64748b;\r\n}\r\n\r\n.championship-editor-tabs .tabs-content {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 24px;\r\n  background: #0f172a;\r\n}\r\n\r\n.unsaved-changes-indicator {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 12px 20px;\r\n  background: rgba(251, 191, 36, 0.9);\r\n  color: #78350f;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n  z-index: 50;\r\n}\r\n\r\n/* Common form styles for all tabs */\r\n.championship-tab-content {\r\n  max-width: 1200px;\r\n}\r\n\r\n.form-section {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.form-section h3 {\r\n  margin: 0 0 16px 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.form-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.form-group label {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #94a3b8;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.form-group input,\r\n.form-group select,\r\n.form-group textarea {\r\n  padding: 10px 12px;\r\n  background: #1e293b;\r\n  border: 1px solid #475569;\r\n  border-radius: 6px;\r\n  color: #f1f5f9;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n}\r\n\r\n.form-group input:focus,\r\n.form-group select:focus,\r\n.form-group textarea:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n.form-group textarea {\r\n  resize: vertical;\r\n  min-height: 80px;\r\n}\r\n\r\n.form-group input[type=\"checkbox\"] {\r\n  width: auto;\r\n  cursor: pointer;\r\n}\r\n\r\n.checkbox-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.checkbox-group input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n}\r\n\r\n.checkbox-group label {\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n/* Championship draft/live status toggle */\r\n.champ-status-section {\r\n  background: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  padding: 12px 16px !important;\r\n}\r\n\r\n.champ-status-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.champ-status-badge {\r\n  display: inline-block;\r\n  padding: 3px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.champ-status-badge.draft {\r\n  background: #374151;\r\n  color: #9ca3af;\r\n  border: 1px solid #4b5563;\r\n}\r\n\r\n.champ-status-badge.live {\r\n  background: #14532d;\r\n  color: #4ade80;\r\n  border: 1px solid #16a34a;\r\n}\r\n\r\n.champ-status-hint {\r\n  font-size: 13px;\r\n  color: #94a3b8;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.champ-status-toggle {\r\n  padding: 6px 14px;\r\n  border-radius: 5px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  border: none;\r\n  flex-shrink: 0;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.champ-status-toggle.publish {\r\n  background: #16a34a;\r\n  color: #fff;\r\n}\r\n\r\n.champ-status-toggle.publish:hover {\r\n  background: #15803d;\r\n}\r\n\r\n.champ-status-toggle.unpublish {\r\n  background: #374151;\r\n  color: #d1d5db;\r\n}\r\n\r\n.champ-status-toggle.unpublish:hover {\r\n  background: #1f2937;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
